import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07378656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "simulateDialog" }
const _hoisted_2 = { class: "pl-3" }

import { ElButton, ElTooltip } from "element-plus";
import { computed, onMounted, ref } from "vue";
import PopupWindow from "@/core/popup/components/PopupWindow.vue";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulateDialog',
  props: {
    dialog: { type: Boolean },
    selectedBuffer: {},
    moved: { type: Boolean },
    stoppable: { type: Boolean },
    flowName: {},
    activityId: {},
    wizardEnabled: { type: Boolean }
  },
  emits: [
  "close",
  "downloadLogsAsText",
  "analyze-with-wizard",
],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const bufferValue = ref([]);

const inner = ref<HTMLElement>();

const emit = __emit;

const live = computed(() => bufferValue.value.length);

async function stopSimulation() {
  emit("close");
}

onMounted(() => {
  if (props.selectedBuffer) {
    bufferValue.value = props.selectedBuffer;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PopupWindow, {
      dialog: _ctx.dialog,
      size: 'sm',
      live: live.value,
      fixed: false,
      "fixed-height": false,
      lazyLoad: false,
      moved: _ctx.moved,
      onDownloadLogsAsText: _cache[1] || (_cache[1] = ($event: any) => (emit('downloadLogsAsText'))),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
    }, {
      "header-label": _withCtx(() => [
        _createVNode(_unref(ElTooltip), {
          placement: "top",
          content: _ctx.flowName ? _ctx.flowName : _unref(t)('Flow.ProcessLogs')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.flowName ? _ctx.flowName : _unref(t)("Flow.ProcessLogs")), 1)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "inner",
          ref: inner
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bufferValue.value, (item, index) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "text-sm-start",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ], 512)
      ]),
      footer: _withCtx(() => [
        (_ctx.activityId && _ctx.wizardEnabled)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "btn-oneTeg2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('analyze-with-wizard', _ctx.activityId)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "magic",
                  class: "margin-right-5"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("TeggyAssistant.AnalyzeWithWizard")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.stoppable)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              class: "btn-oneTeg2",
              onClick: stopSimulation
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Common.Close")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dialog", "live", "moved"])
  ], 512))
}
}

})